<div class="home-parent-container" @fadeSlideInOut>
    <div class="header-container">
        <img class="image" src="/assets/img/intro.png" />
        <div class="text-block">
            <h3>{{ selectorService.entitlementsConfig()?.entitlementsTitle }}</h3>

            <div class="punchline">
                {{ selectorService.entitlementsConfig()?.entitlementsPunchLine }}
            </div>
            <hr /> Hi {{ (authService.user()?.displayName?.split(","))![1] }}! {{ selectorService.entitlementsConfig()?.entitlementsDescription }}
        </div>
        @if ( selectorService.entitlements()?.length === 0) {
        <div class="no-entitlements-message">
            {{'NoSubscriptions'| translate}}
        </div>
        } @else if (!selectorService.entitlements()){
        <mat-spinner class="spinner" diameter="40" color="primary"></mat-spinner>
        }
    </div>
    <fieldset class="fieldset" [ngClass]="{
      enabled: status() !== 'updating',
      disabled: status() === 'updating'
    }" [disabled]="status() !== 'updating'">
        <div class="responsive-grid" [@races]="selectorService.entitlements()?.length">
            @for (entitlement of selectorService.entitlements(); track entitlement) {
            <mat-card class="card" (click)="navigateWithSubId(entitlement.subscriptionId)">
                <label class="id-container">
          <strong>
            {{ entitlement.serviceNickname }}
          </strong>
        </label>
                <label class="status-container" (click)="openSettings($event, entitlement)">
          <mat-icon class="settings">settings</mat-icon>
        </label>

                <div class="name-container">
                    {{ entitlement.subscriptionId }}
                </div>

                <div class="owner-container">
                    <label class="card-sub-title">{{'Owner'| translate}}</label>
                    <div class="user-tag" *ngIf="findMemberByRole(entitlement.team, 'owner') as member" matTooltip="{{ member?.firstName }} {{ member?.lastName }}">
                        {{ member?.firstName?.substring(0, 1) }}{{ member?.lastName?.substring(0, 1) }}
                    </div>
                </div>

                <!--   <div class="create-date-container">
                    <label class="card-sub-title">{{'CreationDate'| translate}}</label>
                    <div class="date">{{ getDate() }}</div>
                </div> -->

                <div class="team-container">
                    <label class="card-sub-title">{{'Team' | translate }}</label>
                    <div class="bubble-container">
                        @for (member of entitlement.team.slice(0, 3); track member) {
                        <div class="user-tag overlap" matTooltip="{{ getUserList(entitlement.team) }}" matTooltipClass="multiline-tooltip">
                            {{ member?.firstName?.substring(0, 1) }}{{ member?.lastName?.substring(0, 1) }}
                        </div>
                        } @if (entitlement.team.length == 4) {
                        <div class="user-tag overlap" matTooltip="{{ getUserList(entitlement.team) }}" matTooltipClass="multiline-tooltip">
                            {{ entitlement?.team?.[3]?.firstName?.substring(0, 1) }}{{ entitlement?.team?.[3]?.lastName?.substring(0, 1) }}
                        </div>
                        } @if (entitlement.team.length > 4) {
                        <div class="user-tag overlap" matTooltip="{{ getUserList(entitlement.team) }}" matTooltipClass="multiline-tooltip">
                            ...
                        </div>
                        }
                    </div>
                </div>
            </mat-card>
            }
        </div>
    </fieldset>
</div>